export const convertInchesToFtString = (rawInches: number): string => {
  const feet = Math.floor(rawInches / 12);
  const inches = rawInches - feet * 12;
  return `${feet}'${inches}`;
};

export const convertFtStringToInches = (ftString: string): number => {
  const [feet, inches] = ftString?.replace(/"/g, '').split("'");

  const feetInt = parseInt(feet, 10);
  const inchesInt = parseInt(inches, 10) || 0;

  return feetInt * 12 + inchesInt;
};

export const convertInchesToUkString = (
  rawInches?: number | null
): string | null => {
  const isNumber = typeof rawInches === 'number';
  if (!isNumber) return null;

  const feet = Math.floor(rawInches / 12);
  const inches = rawInches - feet * 12;
  const centimeters = Math.ceil(rawInches * 2.54);

  const result = `${feet} ft ${inches} in / ${centimeters} cm`;
  return result;
};

export const validateHeight = (rules, height: string): Promise<any> => {
  if (!height) return Promise.reject();
  const feet = height.includes("'")
    ? parseInt(height.split("'")[0])
    : parseInt(height[0]);
  if (feet > 7 || feet < 1) return Promise.reject('Enter a valid height');
  return Promise.resolve(); // valid
};

export const parseNumberOrNull = (rawNumber: unknown) => {
  if (Number.isFinite(rawNumber)) return rawNumber as number;

  if (typeof rawNumber === 'string') {
    const parsedNumber = Number(rawNumber);
    return Number.isFinite(parsedNumber) ? parsedNumber : null;
  }

  return null;
};

export const parseNumberToStringOrNull = (rawNumber?: number | null) => {
  if (Number.isFinite(rawNumber)) {
    return rawNumber.toString();
  }
  return null;
};
